export default __webpack_public_path__ + "static/media/Payments.461386c6.svg";